import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'm-deep-badge-crimson',
  props: {
    text: { default: '深度' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})